// Implements: F-VER-004
/**
 * A byte count as text, in the units a person reads: B, KB or MB.
 *
 * One decimal at most, in the platform locale (`types/locale.ts`). A size that is not a
 * non-negative finite number is shown as zero rather than as `NaN B`, which
 * is what a malformed field would otherwise put in front of somebody.
 */

import { PLATFORM_COUNT_GROUPING, PLATFORM_LOCALE } from "../../types/locale";

const UNIT = 1024;
const NUMBER = new Intl.NumberFormat(PLATFORM_LOCALE, { maximumFractionDigits: 1, useGrouping: PLATFORM_COUNT_GROUPING });

export function byteText(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return "0 B";
  if (bytes < UNIT) return `${String(bytes)} B`;
  if (bytes < UNIT * UNIT) return `${NUMBER.format(bytes / UNIT)} KB`;
  return `${NUMBER.format(bytes / (UNIT * UNIT))} MB`;
}
